import * as uuid from 'uuid';
import { WebSocketSendMessage } from './web-socket-send-message';
import { WebSocketPayloadActionData } from '../../actions/web-socket-payload-action-data';

export class WebSocketSendRequestDataMessage extends WebSocketSendMessage {
  /**
   * This works a little differently than the dashboard app. The entity id is stored in the web socket service,
   * so as this message is about to go out the door, the web socket service will add the entity id to the message.
   */
  constructor() {
    super();
    const requestId = uuid.v4();
    this.action = WebSocketPayloadActionData.REQUEST;
    this.payload = {
      requestId,
      metadata: {
        Source: 'Display'
      }
    };
  }

  getPayloadRequestId(): string {
    return this.payload.requestId;
  }
}
